import React, { useEffect } from "react"
import Layout from "../components/layout"
import Logo from "../components/logo"
import SEO from "../components/seo"
import StoriesListElement from '../components/StoriesList'
import Story from './storyTemplate'
import { graphql } from 'gatsby'
import { useMediaQuery } from 'react-responsive'
import styled from 'styled-components'

const Stories = ({data}) => {
  const Stories = styled.div`
    @media (max-width: 1024px) {
      .logo-wrapper {
        width: 100%;
        padding-bottom: 25px;
      }

      .stories-list-wrapper {
        display: none;
      }
    }

    @media (min-width: 1025px) {
      .logo-wrapper {
        position: relative;
        top: -30px;
        left: 160px;
        width: 300px;
      }
    }
  `

  useEffect(() => console.log())
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1023px)' });
  console.log(data.markdownRemark.excerpt);
  return (
    <Layout>
      <SEO 
        title={data.markdownRemark.frontmatter.title} 
        image={data.markdownRemark.frontmatter.image.childImageSharp.fluid.src}
        description={data.markdownRemark.excerpt}
        />
      <Stories>     
        <div className="logo-wrapper">
          <Logo width={isTabletOrMobile ? '180px' : '240px'} margin='0' />
        </div>
        <div className='columns is-centered' style={{height: 'calc(100vh - 181px'}}>
          <div className='stories-list-wrapper'>
            <StoriesListElement currentStory={data.markdownRemark.fields.slug} />
          </div>
          <div className={`column is-centered is-paddingless is-three-fifths`} style={{height: 'calc(100vh - 181px'}}>
            <Story width='95' data={data} />
          </div>
        </div>
      </Stories>
    </Layout>
  )
}

export const storyQuery = graphql`
  query($title: String!, $imageFocus: ImageCropFocus) {
    allMarkdownRemark(
      filter: { frontmatter: { templateKey: { eq: "storiesTemplate" } } }
    ) {
      edges {
        node {
          id
        }
      }
    }
    markdownRemark(frontmatter: { title: { eq: $title } }) {
      html
      excerpt(pruneLength: 100)
      fields {
        slug
      }
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        title
        image {
          publicURL
          childImageSharp {
            fluid(maxWidth: 900, maxHeight: 280, quality: 75, cropFocus: $imageFocus) {
              ...GatsbyImageSharpFluid
              src
            }
          }
        }
      }
    }
  }
`

export default Stories

